import { useState, useCallback, useEffect } from "react";
import { Select, Form, Table, Spin, Input, Button, DatePicker, Checkbox } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import { useSelector, useDispatch } from "react-redux";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import csv from "../../assets/images/csv.png";
import { SearchOutlined, FilterFilled } from "@ant-design/icons";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import Loader from "react-spinners/BarLoader";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import { getSpecialityByStyle } from "../../redux/actions/specialityByStyle";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import { currencySymbol } from "../../utils/constants";
import { getRegion } from "../../redux/actions/region.action";

const { Option } = Select;
const SpecialtyByStyle = ({ token }) => {
    TabTitle("Customer-By-Style");
    const menuId = ReadCookie("menuId");
    const userName = ReadCookie("name");
    const company_id = ReadCookie("defaultCompany");
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { saleOrderFormData, OmsReprot, SpecialityByStyle, region } = useSelector(
        (state) => state
    );
    const [loading, setLoading] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [filters, setFilters] = useState([]);
    const [allStatus, setAllStatus] = useState(true);
    const [allFilters, setAllFilters] = useState([
        { id: 1, name: "Shipped", selected: false },
        { id: 2, name: "Return", selected: false },
        { id: 3, name: "POD", selected: false },
        { id: 4, name: "Pending", selected: false },
    ]);
    const [ptfilters, setPtFilters] = useState([]);
    const [ptAllStatus, setPtAllStatus] = useState(true);
    const [ptAllFilters, setPtAllFilters] = useState([
        { id: 1, name: "Released to Bergen", selected: false },
        { id: 2, name: "Pending Payment", selected: false },
        { id: 3, name: "Reserved", selected: false },
        { id: 5, name: "Release to Bergen (Not send)", selected: false },
    ]);

    const statusSelectAll = (e) => {
        let copyArr = [...allFilters];
        copyArr.map((v) => {
            v.selected = false;;
            return v;
        });
        setAllFilters(copyArr);
        setAllStatus(e.target.checked);
    };

    useEffect(() => {
        if (allStatus) {
            setFilters([]);
        }
    }, [allStatus])

    const statusPTSelectAll = (e) => {
        let copyArr = [...ptAllFilters];
        copyArr.map((v) => {
            v.selected = false;;
            return v;
        });
        setPtAllFilters(copyArr);
        setPtAllStatus(e.target.checked);
    };

    useEffect(() => {
        if (ptAllStatus) {
            setPtFilters([]);
        }
    }, [ptAllStatus])

    const handlePrint = () => {
        window.print();
    };

    const handleChanges = (val) => {
        dispatch(getSaleOrderFormData(token, company_id, menuId, val, ""));
    };

    function debounce(cb, delay = 1000) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                cb(...args);
            }, delay);
        };
    }

    useEffect(() => {
        dispatch(getRegion(token, menuId));
    }, [dispatch, menuId, token]);

    const optimizedFn = useCallback(debounce(handleChanges), []);

    const onFinish = async (e) => {
        setLoading(true);
        await form.validateFields().then((values) => {
            let status = []
            allFilters.filter((item) => {
                if (item.selected === true) {
                    status.push(item.id)
                }
                return item;
            });
            let ptStatus = []
            ptAllFilters.filter((item) => {
                if (item.selected === true) {
                    ptStatus.push(item.id)
                }
                return item;
            });
            dispatch(getSpecialityByStyle(token, values, status, ptStatus)).then((res) => {
                setLoading(false);
                downloadExcelFileData(res?.payload?.data);
            });
        });
    };

    function downloadExcelFileData(data) {
        setExcelData(
            data.map((v) => {
                return {
                    Division: v.gender_name,
                    Region: v.region_name,
                    Customer: v.customer_name,
                    Year: v.years,
                    Month: v.months,
                    Status: v.status,
                    "PO NO": v.reference_no,
                    "Tran Type": v.tran_type,
                    "Tran No": v.tran_no,
                    "Start Date": moment(v.start_date).format("MM-DD-YYYY"),
                    "Cancel Date": moment(v.cancel_date).format("MM-DD-YYYY"),
                    SKU: v.sku,
                    Inseam: v.inseam,
                    Style: v.style_name,
                    Wash: v.wash_name,
                    "PT Status": v.pt_status_name,
                    "tracking Status": v.tracking_status,
                    "CC Charge Status": v.cc_charge_status,
                    "CIT Status": v.factor_decision,
                    "Amount C$": v.shipped_amount,
                    Unit: v.unit,
                };
            })
        );
    }

    const columns = [
        {
            title: "#",
            width: 40,
            // className: "b_bottom",
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: "Division",
            dataIndex: "gender_name",
            key: "gender_name",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.gender_name !== null) {
                    return record.gender_name
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.gender_name !== null) & (b.gender_name !== null)) {
                    return a.gender_name.localeCompare(b.gender_name);
                }
            },
        },
        {
            title: "Region",
            dataIndex: "region_name",
            key: "region_name",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.region_name !== null) {
                    return record.region_name
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.region_name !== null) & (b.region_name !== null)) {
                    return a.region_name.localeCompare(b.region_name);
                }
            },
        },
        {
            title: "Customer",
            dataIndex: "customer_name",
            key: "customer_name",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.customer_name !== null) {
                    return record.customer_name
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.customer_name !== null) & (b.customer_name !== null)) {
                    return a.customer_name.localeCompare(b.customer_name);
                }
            },
        },
        {
            title: "Year",
            dataIndex: "years",
            key: "years",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.years !== null) {
                    return record.years
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                return a.years - b.years;
            },
        },
        {
            title: "Month",
            dataIndex: "months",
            key: "months",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.months !== null) {
                    return record.months
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.months !== null) & (b.months !== null)) {
                    return a.months.localeCompare(b.months);
                }
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.status !== null) {
                    return record.status
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.status !== null) & (b.status !== null)) {
                    return a.status.localeCompare(b.status);
                }
            },
        },
        {
            title: "PO NO",
            dataIndex: "reference_no",
            key: "reference_no",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.reference_no !== null) {
                    return record.reference_no
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.reference_no !== null) & (b.reference_no !== null)) {
                    return a.reference_no.localeCompare(b.reference_no);
                }
            },
            render: (text, record) => {
                return (
                    <Link
                        style={{ color: "#0d6efd", textDecoration: "underline" }}
                        to={
                            "/quick-po-lookup?poNumber=" + record?.reference_no
                        }
                    >
                        {text}
                    </Link>
                );
            },
        },
        {
            title: "Tran Type",
            dataIndex: "tran_type",
            key: "tran_type",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.tran_type !== null) {
                    return record.tran_type
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.tran_type !== null) & (b.tran_type !== null)) {
                    return a.tran_type.localeCompare(b.tran_type);
                }
            },
        },
        {
            title: "Tran No",
            dataIndex: "tran_no",
            key: "tran_no",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.tran_no !== null) {
                    return record.tran_no
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                return a.tran_no - b.tran_no;
            },
            render: (text, record) => {
                return (
                    <Link
                        style={{ color: "#0d6efd", textDecoration: "underline" }}
                        to={
                            record?.tran_type === "Sale Order"
                                ? "/sale-order?mode=edit&order_id=" +
                                record.tran_id +
                                "/&customer_id/" +
                                record.customer_id +
                                "?edit=yes"
                                : record?.tran_type === "Pickticket"
                                    ? "/order-shipment?mode=edit&order_id=" +
                                    record.tran_id +
                                    "&customer_id/" +
                                    record.customer_id +
                                    "?edit=yes"
                                    : record?.tran_type === "Invoice"
                                        ? "/invoice?mode=edit" +
                                        "&invoice_header_id=" +
                                        record.tran_id +
                                        "&customer_id=" +
                                        record.customer_id
                                        : record?.tran_type === "Item Reciept"
                                            ? "/item-receipt-new?mode=edit&return_id=" + record.tran_id
                                            : ""
                        }
                    >
                        {text}
                    </Link>
                );
            },
        },
        {
            title: "Start Date",
            dataIndex: "start_date",
            key: "start_date",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.start_date !== null) {
                    return record.start_date
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.start_date !== null) & (b.start_date !== null)) {
                    return a.start_date.localeCompare(b.start_date);
                }
            },
            render: (text, record) => {
                return moment(record.start_date).format("MM-DD-YYYY")
            },
        },
        {
            title: "Cancel Date",
            dataIndex: "cancel_date",
            key: "cancel_date",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.cancel_date !== null) {
                    return record.cancel_date
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.cancel_date !== null) & (b.cancel_date !== null)) {
                    return a.cancel_date.localeCompare(b.cancel_date);
                }
            },
            render: (text, record) => {
                return moment(record.cancel_date).format("MM-DD-YYYY")
            },
        },
        {
            title: "SKU",
            dataIndex: "sku",
            key: "sku",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.sku !== null) {
                    return record.sku
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                return a.sku - b.sku;
            },
        },
        {
            title: "Inseam",
            dataIndex: "inseam",
            key: "inseam",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.inseam !== null) {
                    return record.inseam
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                return a.inseam - b.inseam;
            },
        },
        {
            title: "Style",
            dataIndex: "style_name",
            key: "style_name",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.style_name !== null) {
                    return record.style_name
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.style_name !== null) & (b.style_name !== null)) {
                    return a.style_name.localeCompare(b.style_name);
                }
            },
        },
        {
            title: "Wash",
            dataIndex: "wash_name",
            key: "wash_name",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.wash_name !== null) {
                    return record.wash_name
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.wash_name !== null) & (b.wash_name !== null)) {
                    return a.wash_name.localeCompare(b.wash_name);
                }
            },
        },
        {
            title: "PT Status",
            dataIndex: "pt_status_name",
            key: "pt_status_name",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.pt_status_name !== null) {
                    return record.pt_status_name
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.pt_status_name !== null) & (b.pt_status_name !== null)) {
                    return a.pt_status_name.localeCompare(b.pt_status_name);
                }
            },
        },
        {
            title: "Tracking Status",
            dataIndex: "tracking_status",
            key: "tracking_status",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.tracking_status !== null) {
                    return record.tracking_status
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.tracking_status !== null) & (b.tracking_status !== null)) {
                    return a.tracking_status.localeCompare(b.tracking_status);
                }
            },
        },
        {
            title: "CC Charge Status",
            dataIndex: "cc_charge_status",
            key: "cc_charge_status",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.cc_charge_status !== null) {
                    return record.cc_charge_status
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.cc_charge_status !== null) & (b.cc_charge_status !== null)) {
                    return a.cc_charge_status.localeCompare(b.cc_charge_status);
                }
            },
        },
        {
            title: "CIT Status",
            dataIndex: "factor_decision",
            key: "factor_decision",
            // className: " b_left b_bottom",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.factor_decision !== null) {
                    return record.factor_decision
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                if ((a.factor_decision !== null) & (b.factor_decision !== null)) {
                    return a.factor_decision.localeCompare(b.factor_decision);
                }
            },
        },
        {
            title: "Amount " + currencySymbol,
            dataIndex: "shipped_amount",
            key: "shipped_amount",
            align: "right",
            render: (text, record) => {
                return numeral(record.shipped_amount).format("0");
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.shipped_amount !== null) {
                    return record.shipped_amount
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                return a.shipped_amount - b.shipped_amount;
            },
        },
        {
            title: "Unit",
            dataIndex: "unit",
            key: "unit",
            align: "right",
            render: (text, record) => {
                return numeral(record.unit).format("0");
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            allowClear
                            autoFocus
                            className="pop-search-gen pop-220"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) => {
                if (record.unit !== null) {
                    return record.unit
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            },
            sorter: (a, b) => {
                return a.unit - b.unit;
            },
        },
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <div className="report-wrapper-main header_class">
                            <div className="row justify-content-between pb-2">
                                <div className="col-3 d-flex align-items-start  box-space">
                                    <div className="logobrand">
                                        <img id="ImgLogo" alt="logo" src={logo} />
                                    </div>
                                </div>
                                <div className="col-sm-4 box-space right-content-header text-right pb-0">
                                    <div className=" d-flex justify-content-end">
                                        <div className=" d-flex justify-content-end printing_class mr-8">
                                            <div className="print_icon printing_class">
                                                {OmsReprot?.payload?.data.length ? (
                                                    <i
                                                        id="Image1"
                                                        title="Print"
                                                        alt="Print"
                                                        src={btnPrint}
                                                        className="fa-solid fa-print printing_class"
                                                    ></i>
                                                ) : (
                                                    <i
                                                        id="Image1"
                                                        title="Print"
                                                        alt="Print"
                                                        src={btnPrint}
                                                        className="fa-solid fa-print printing_class"
                                                        onClick={handlePrint}
                                                    ></i>
                                                )}
                                            </div>
                                            <div className="print_icon printing_class">
                                                <CSVLink
                                                    filename={"Customer-By-Style.csv"}
                                                    data={excelData}
                                                    onClick={() => { }}
                                                >
                                                    <input
                                                        type="image"
                                                        name="ImgExcel"
                                                        alt="Export to excel"
                                                        id="ImgExcel"
                                                        title="Export to excel"
                                                        src={csv}
                                                        style={{ borderWidth: "0px", height: "14px" }}
                                                    />
                                                </CSVLink>
                                            </div>
                                        </div>
                                        <span style={{ fontWeight: "bolder" }}>
                                            Customer By Style
                                            <br />
                                            Rpt # 006
                                            <br />
                                            Login as:
                                            <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                                                {" "}
                                                {userName}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row printing_class">
                                <div className="col text-sm-right pb-1"></div>
                            </div>
                            <>
                                <div className="business_class_oms mb-2 distributor">
                                    <Form form={form} name="control-hooks" onFinish={onFinish}>
                                        <div className="main_form row">
                                            <hr className="my-1" />
                                            <div className="row">
                                                <div className="checkboxes">
                                                    <label htmlFor="" style={{ marginRight: "35px" }}>Status:</label>
                                                    <div className="checkbox_content">
                                                        <Form.Item name="current_status_id" className=" mb-0">
                                                            <Checkbox
                                                                checked={allStatus} onChange={statusSelectAll}
                                                            >
                                                                All
                                                            </Checkbox>
                                                        </Form.Item>
                                                    </div>
                                                    {allFilters &&
                                                        allFilters.map((it, index) => {
                                                            return (
                                                                <div key={index} className="checkbox_content">
                                                                    <Form.Item name="current_status_id">
                                                                        <Checkbox
                                                                            checked={it.selected}


                                                                            onChange={(e) => {
                                                                                let copyArr = [...allFilters];
                                                                                if (e.target.checked) {
                                                                                    copyArr[index].selected = true;
                                                                                } else {
                                                                                    copyArr[index].selected = false;
                                                                                }
                                                                                setAllFilters(copyArr);
                                                                                setAllStatus(false);
                                                                            }}
                                                                        >
                                                                            {it.name}
                                                                        </Checkbox>
                                                                    </Form.Item>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="checkboxes">
                                                    <label htmlFor="" style={{ marginRight: "15px" }}>PT Status:</label>
                                                    <div className="checkbox_content">
                                                        <Form.Item name="pt_current_status_id" className=" mb-0">
                                                            <Checkbox
                                                                checked={ptAllStatus} onChange={statusPTSelectAll}
                                                            >
                                                                All
                                                            </Checkbox>
                                                        </Form.Item>
                                                    </div>
                                                    {ptAllFilters &&
                                                        ptAllFilters.map((it, index) => {
                                                            return (
                                                                <div key={index} className="checkbox_content">
                                                                    <Form.Item name="pt_current_status_id">
                                                                        <Checkbox
                                                                            checked={it.selected}
                                                                            onChange={(e) => {
                                                                                let copyArr = [...ptAllFilters];
                                                                                if (e.target.checked) {
                                                                                    copyArr[index].selected = true;
                                                                                } else {
                                                                                    copyArr[index].selected = false;
                                                                                }
                                                                                setPtAllFilters(copyArr);
                                                                                setPtAllStatus(false);
                                                                            }}
                                                                        >
                                                                            {it.name}
                                                                        </Checkbox>
                                                                    </Form.Item>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                            <hr className="my-1" />
                                            <div className="main_form row">
                                                <div className="col-12 col-md-4">
                                                    <div className=" d-flex flex-row align-items-baseline">
                                                        <label className="labels width44">
                                                            From Month:
                                                        </label>
                                                        <div className="w-100">
                                                            <Form.Item
                                                                className="full_date"
                                                                name="from_date"
                                                                initialValue={moment().startOf("year")}
                                                            >
                                                                <DatePicker
                                                                    size="small"
                                                                    defaultValue={moment().format("MM-YYYY")}
                                                                    className={"input-width"}
                                                                    picker="month"
                                                                    format={"MM-YYYY"}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <div className=" d-flex flex-row align-items-baseline">
                                                        <label className="labels width44">To Month:</label>
                                                        <div className="w-100">
                                                            <Form.Item
                                                                className="full_date"
                                                                name="to_date"
                                                                initialValue={moment().endOf("year")}
                                                            >
                                                                <DatePicker
                                                                    size="small"
                                                                    defaultValue={moment().format("MM-YYYY")}
                                                                    className={"input-width"}
                                                                    picker="month"
                                                                    format={"MM-YYYY"}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <div className=" d-flex flex-row align-items-baseline">
                                                        <label htmlFor="" className="labels width30">
                                                            Customer:
                                                        </label>
                                                        <div className="w-100">
                                                            <Form.Item name="customer" initialValue={"All"}>
                                                                <Select
                                                                    notFoundContent={
                                                                        saleOrderFormData.loading ? (
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                <Loader
                                                                                    type="Oval"
                                                                                    color="#3c4b58"
                                                                                    height={20}
                                                                                    width={20}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    textAlign: "center",
                                                                                }}
                                                                            >
                                                                                No Data
                                                                            </div>
                                                                        )
                                                                    }
                                                                    className={"select_Inputs"}
                                                                    autoComplete={"nope"}
                                                                    allowClear
                                                                    size="small"
                                                                    showSearch
                                                                    optionFilterProp="children"
                                                                    loading={saleOrderFormData.loading}
                                                                    defaultValue={form.getFieldValue().customer}
                                                                    placeholder="Select Customer"
                                                                    onSearch={(value) => {
                                                                        optimizedFn(value);
                                                                    }}
                                                                >
                                                                    <Option value="All">All</Option>
                                                                    {saleOrderFormData?.payload?.customerDetail.map(
                                                                        (item) => {
                                                                            return (
                                                                                <Option
                                                                                    defaultValue={"All"}
                                                                                    key={item.customer_id}
                                                                                    value={item.customer_id}
                                                                                >
                                                                                    {" "}
                                                                                    {`${item.customer_code} - ${item.customer_name}`}
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                                </Select>
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="main_form row form-margin">
                                                <div className="col-12 col-md-4">
                                                    <div className=" d-flex flex-row align-items-baseline">
                                                        <label className="labels width44">Region:</label>
                                                        <div className="w-100">
                                                            <Form.Item name="region" initialValue={"All"}>
                                                                <Select
                                                                    className={"select_Inputs"}
                                                                    showSearch
                                                                    optionFilterProp="children"
                                                                    size="small"
                                                                    filterOption={(input, option) =>
                                                                        option.children
                                                                            .toLowerCase()
                                                                            .includes(input.toLowerCase())
                                                                    }
                                                                    filterSort={(optionA, optionB) =>
                                                                        optionB?.value !== null ?
                                                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                                    }
                                                                >
                                                                    <Option value={null}>All</Option>
                                                                    {
                                                                        region?.payload?.data.map((val) => {
                                                                            return (
                                                                                <Option key={val.region_id} value={val.region_id}>{val.region_name}</Option>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4">
                                                    <div
                                                        className=" d-flex flex-row align-items-baseline"
                                                        style={{
                                                            justifyContent: "start",
                                                            marginTop: "3px",
                                                        }}
                                                    >
                                                        <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            className="submit-btn-btm m-0"
                                                        >
                                                            Generate
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </>
                        </div>
                        <div>
                            {/* <div className="col"> */}
                            <div className="mt-3">
                                <>
                                    {/* Report 1 */}
                                    {loading ? (
                                        <div className="maxWidth d-flex align-items-center justify-content-center spin-style mt-3">
                                            <Spin />
                                        </div>
                                    ) : SpecialityByStyle?.payload?.data.length ? (
                                        <Table
                                            showSorterTooltip={false}
                                            className="fix-scroll-table  table-header-sticky  border-line-th  bottom-align-th  table-td-border-right  th-general-style  
                                 td-general-style  even-tr-style border"
                                            size="small"
                                            pagination={{
                                                defaultCurrent: 1,
                                                defaultPageSize: 100,
                                                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
                                            }}
                                            bordered
                                            columns={columns}
                                            dataSource={
                                                SpecialityByStyle?.payload?.data
                                                    ? SpecialityByStyle?.payload?.data
                                                    : []
                                            }
                                            summary={pageData => {
                                                let Amount = pageData.reduce(function (previousValue, currentValue) {
                                                    return previousValue += parseFloat(currentValue.shipped_amount)
                                                }, 0);
                                                let Unit = pageData.reduce(function (previousValue, currentValue) {
                                                    return previousValue += parseFloat(currentValue.unit)
                                                }, 0);
                                                return (
                                                    <>
                                                        <Table.Summary.Row>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell className="sales_table_summary">
                                                                <p style={{ fontWeight: "bolder", textAlign: "center" }}>Total:</p>
                                                            </Table.Summary.Cell>
                                                            <Table.Summary.Cell className="sales_table_summary">
                                                                <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                                                                    {currencySymbol}{numeral(Amount.toLocaleString("en-US")).format("0,00")}
                                                                </p>
                                                            </Table.Summary.Cell>
                                                            <Table.Summary.Cell className="sales_table_summary">
                                                                <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                                                                    {numeral(Unit.toLocaleString("en-US")).format("0,00")}
                                                                </p>
                                                            </Table.Summary.Cell>
                                                        </Table.Summary.Row>
                                                    </>
                                                );
                                            }}
                                            scroll={{ x: "max-content" }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                backgroundColor: "#CCCCCC",
                                                borderWidth: "1pt",
                                                borderStyle: "Dashed",
                                                fontWeight: "bold",
                                                height: "25px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            No record(s)
                                        </div>
                                    )}
                                </>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SpecialtyByStyle;
